//Importaciones
import React, { useContext } from 'react'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { enum__BOARD_TEMPLATE_TYPE, enum__COMPONENT_SIMPLE_COLOR_TYPE, enum__ComponentType, enum__ComponentType_InvertedEnum } from '../../../../common/Dictionaries';
import ELEMENT_STADISTICS from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_STADISTICS';
import SG3_HEADER from '../../../../components/Products/sKPI/Board/_ComponentTypes/SG3_HEADER';
import ELEMENT_ROLES from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_ROLES';
import CONTRACT_SERVICES from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_SERVICES';
import CONTRACT_SERVICES_STATUS from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_SERVICES_STATUS';
import CONTRACT_KPI_COVERAGE from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_KPI_COVERAGE';
import CONTRACT_LAST_EDP from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONTRACT_LAST_EDP';
import SG3KPI_CONSOLIDATE_MONTH from '../../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_CONSOLIDATE_MONTH';
import ELEMENT_BOOK_SUMMARY from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_BOOK_SUMMARY';
import OCR_CHART from '../../../../components/Products/sKPI/Board/_ComponentTypes/OCR_CHART';
import ELEMENT_LAST_MOVEMENTS from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_LAST_MOVEMENTS';
import ELEMENT_OBLIGATIONS_CONTROL from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_OBLIGATIONS_CONTROL';
import ELEMENT_KPI_COMMENT_EVENT from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_COMMENT_EVENT';
import ELEMENT_CONTRACT_SEGMENT from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_SEGMENT';
import ELEMENT_CONTRACT_CATEGORY from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_CATEGORY';
import ELEMENT_CONTRACT_PORTFOLIO_SUMMARY from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_PORTFOLIO_SUMMARY';
import ELEMENT_CONTRACT_KPI_DETAIL from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_KPI_DETAIL';
import ELEMENT_KPI_FTE_CHART from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_FTE_CHART';
import ELEMENT_KPI_AMOUNT from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_AMOUNT';
import ELEMENT_KPI_FTE_TREE from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_FTE_TREE';
import PRODUCTS from '../../../../components/Products/sKPI/Board/_ComponentTypes/PRODUCTS';
import ELEMENT_KPI_VARIABLE_DETAILS from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_VARIABLE_DETAILS';
import ELEMENT_BOOK_STATUS_SUMMARY from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_BOOK_STATUS_SUMMARY';
import INFO_TYPETEXT from '../../../../components/Products/sKPI/Board/_ComponentTypes/INFO_TYPETEXT';
import { getLocalStorageValue, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import INFO_COMMENT from '../../../../components/Products/sKPI/Board/_ComponentTypes/INFO_COMMENT';
import INFO_CUSTOMTEXT from '../../../../components/Products/sKPI/Board/_ComponentTypes/INFO_CUSTOMTEXT';
import INFO_FINANCIAL from '../../../../components/Products/sKPI/Board/_ComponentTypes/INFO_FINANCIAL';
import ELEMENT_CONTRACT_EXPENSE_BALANCE from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EXPENSE_BALANCE';
import ELEMENT_CONTRACT_SERVICE_SUMMARY from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_SERVICE_SUMMARY';
import ELEMENT_CONTRACT_LIST_LAST_EDP from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_LIST_LAST_EDP';
import ELEMENT_CONTRACT_EDP_COVER from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EDP_COVER';
import ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL';
import ELEMENT_CONTRACT_LAST_EDP from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_LAST_EDP';
import ELEMENT_KPI_SUMMARY from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_SUMMARY';
import SG3KPI_RADIAL from '../../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_RADIAL';
import InfoListDynamic from '../../../../components/Products/sKPI/Board/_ComponentTypes/Information/InfoListDynamic';
import SG3KPI_RADIALOPF from '../../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_RADIALOPF';
import ELEMENT_KPI_SCOPE from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_KPI_SCOPE';
import i18next from 'i18next';
import SG3KPI_MONITORING from '../../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_MONITORING';
import SG3KPI_CONTRACT_ADVANCE from '../../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_CONTRACT_ADVANCE';
import SG3KPI_LASTOPF from '../../../../components/Products/sKPI/Board/_ComponentTypes/SG3KPI_LASTOPF';
import BoardList from '../../../../components/Products/sKPI/Board/BoardBox/BoardListNew';
import BoardListGrouped from '../../../../components/Products/sKPI/Board/BoardBox/BoardListNew/BoardListGrouped';
import { BOARD_AGRUPATION_WHEN_NULL } from '../../../../configurations/application.config';
import { Card, Col, Row } from 'react-bootstrap';
import CONSOLIDATE_GROUP_CONSOLIDATE_OPF from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_CONSOLIDATE_OPF';
import CONSOLIDATE_GROUP_CONSOLIDATE_CHART from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_CONSOLIDATE_CHART/index';
import CONSOLIDATE_GROUP_LIST_TO_SELECT from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_LIST_TO_SELECT/index';
import CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE';
import ELEMENT_CONTRACT_LIST_TO_COMPARE from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_LIST_TO_COMPARE';
import ELEMENT_CONTRACT_EDP_RESUMEN from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EDP_RESUMEN';
import ELEMENT_CONTRACT_MOTNHS from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_MOTNHS';
import ELEMENT_CONTRACT_EDP_DISTRIBUCION from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EDP_DISTRIBUCION';
import ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH';
import ELEMENT_CONTRACT_EDP_MONTOS_GRAPH from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EDP_MONTOS_GRAPH';
import ELEMENT_CONTRACT_EDP_PARTIDAS_TBL from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EDP_PARTIDAS_TBL';
import moment from 'moment';
import ELEMENT_CONTRACT_HOME_EXTERNAL from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_HOME_EXTERNAL_CONTRACTS';
import ELEMENT_CONTRACT_HOME_EXTERNAL_KPI_SCOPE from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_HOME_EXTERNAL_KPI_SCOPE';
import OCR_CHART_LIST from '../../../../components/Products/sKPI/Board/_ComponentTypes/OCR_CHART_LIST';
import ELEMENT_CONTRACT_EXCHANGE_RATE from '../../../../components/Products/sKPI/Board/_ComponentTypes/ELEMENT_CONTRACT_EXCHANGE_RATE';
import POWERBI_COMPONENT_TABLE from '../../../../components/Products/sKPI/Board/_ComponentTypes/POWERBI_COMPONENT_TABLE';
import POWERBI_COMPONENT_KEY_KPIS from '../../../../components/Products/sKPI/Board/_ComponentTypes/POWERBI_COMPONENT_KEY_KPIS';
import POWERBI_COMPONENT_OCR from '../../../../components/Products/sKPI/Board/_ComponentTypes/POWERBI_COMPONENT_OCR';
import Loading from '../../../../components/Templates/Site/Loading';
import CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE';

function BoardComponentInfoContent(props) {
    //Helpers
    const { t, i18n } = useTranslation();
    
    const { token: currentAuth } = useSelector((state) => state.auth);

    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);

    //Parametros de entrada.
    const { 
        inputParam_ElementId = null,
        inputParam_ContainerComponent = null,
        inputParam_BoardType = null,
        inputParam_BoardId = null,
        inputParam_ReportHeaderMode = false,
        inputParam_HasPageElementId = false,
        inputParam_BoardStructure = null,
        inputParam_Container = null,
        inputParam_Index = null,
        setBoardVariableDataserieValues = null,
        inputParam_UserPropsKpi = null,
        inputParam_ContainerComponentIndex = null,
        inputParam_ContextualChart = true,
        inputParam_OnMaximize = null,
        inputParam_IsMaximized= 'normal'
    } = props;

    const [groupDataseriesInOneList, setGroupDataseriesInOneList] = useState(getLocalStorageValue('PARAM_COOKIE_DATASERIES_GROUPED' + inputParam_BoardId, BOARD_AGRUPATION_WHEN_NULL));

    const [boardComponentInfoValues, setBoardComponentInfoValues] = useState(null);
    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });
    const [hasInfoMultiComponentType, setHasInfoMultiComponentType] = useState(false)
    
    const findTypeTextEntity = (componentData, component) => {
        if (component.htmlBoardAnexoRef === "AMOUNT") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-contractamount') ,
                    value: parseFloat(parseFloat(componentData.item.amount).toFixed(2)).toLocaleString(i18next.language),
                    um: componentData.item.currency,
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-contractamount') ,
                    value: componentData.item.amount,
                    um: componentData.item.currency,
                }
            }
        }
        else if (component.htmlBoardAnexoRef === "CURRENCY") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-contractconsumption') ,
                    value: componentData.item.currency,
                    um: '',
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-currency') ,
                    value: componentData.item.currency,
                    um: '',
                }
            }
        }
        else if (component.htmlBoardAnexoRef === "CONSUMPTION") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-contractconsumption') ,
                    value: parseFloat(parseFloat(componentData.item.amount - componentData.item.residue).toFixed(2)).toLocaleString(i18next.language),
                    um: componentData.item.currency,
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-contractconsumption') ,
                    value: componentData.item.amount - componentData.item.residue,
                    um: componentData.item.currency,
                }
            }
        }
        else if (component.htmlBoardAnexoRef === "STARTDATE") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-lbl-startdate') ,
                    value: !isNullUndefinedOrEmpty(componentData.item.startDate) ? moment(componentData.item.startDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata'),
                    um: '',
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-lbl-startdate') ,
                    value: null,
                    um: '',
                }
            }
        }
        else if (component.htmlBoardAnexoRef === "ENDDATE") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-lbl-enddate') ,
                    value: !isNullUndefinedOrEmpty(componentData.item.endDate) ? moment(componentData.item.endDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata'),
                    um: '',
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-lbl-enddate') ,
                    value: null,
                    um: componentData.item.currency,
                }
            }
        }
        else if (component.htmlBoardAnexoRef === "BALANCE") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-monthsduration') ,
                    value: !isNullUndefinedOrEmpty(componentData.item.residue) ? parseFloat(parseFloat(componentData.item.residue).toFixed(2)).toLocaleString(i18next.language) : t('data-lang-lbl-nodata'),
                    um: componentData.item.currency,
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-monthsduration') ,
                    value: null,
                    um: '',
                }
            }
        }
        else if (component.htmlBoardAnexoRef === "MONTHS_DURATION") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-monthsduration') ,
                    value: componentData.item.meses_duracion,
                    um: '',
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-monthsduration') ,
                    value: null,
                    um: '',
                }
            }
        }
        else if (component.htmlBoardAnexoRef === "REMAINING_MONTHS") {
            try {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-remainingmonths') ,
                    value: componentData.item.meses_restantes,
                    um: '',
                }
            } catch (error) {
                return {
                    title: !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-remainingmonths') ,
                    value: null,
                    um: '',
                }
            }
        }
    }

    const findDSReportEntity = (dataserie, component) => {
        let flag_special = false;
        let entity = {
            item: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
        }
        let entity2 = {
            item: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
            item2: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
            item3: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
        }

        if (isNullUndefined(dataserie)) {
            dataserie = {
                l_scopes: [],
            }
        }

        const itemVal = isNullUndefined(dataserie.l_scopes) ?
        dataserie.l_vals.length > 0 ?  dataserie.l_vals[0] : (dataserie.l_agg_vals.length > 0 ? dataserie.l_agg_vals[0] : null)
        :
        dataserie.l_scopes.length > 0 ?  (dataserie.l_scopes[0].l_vals.length > 0 ? dataserie.l_scopes[0].l_vals[0] : (!isNullUndefined(dataserie.l_agg_vals) && dataserie.l_agg_vals.length > 0 ? dataserie.l_agg_vals[0] : null)) : null;

        entity.item.title = component.htmlTitle;
        entity.item.color = itemVal !== null ? itemVal.color : t('no-data');

        entity2.item.title = component.htmlTitle;
        entity2.item.color = itemVal !== null ? itemVal.color: t('no-data');

        entity2.item2.title = component.htmlTitle;
        entity2.item2.color = itemVal !== null ? itemVal.color: t('no-data');

        entity2.item3.title = component.htmlTitle;
        entity2.item3.color = itemVal !== null ? itemVal.color: t('no-data');

        switch (JSON.parse(component.htmlStyle).exHtmlId) {
            case "DESEMPEÑO_KPI":
            case "ESTADO_FINANCIERO":
            case "MANEJO_FTE":

            case "SIMPLE_ICON_COLOR_VALUEGOALPERCENT":
                entity.item.titleAux = !isNullUndefined(dataserie.variableName) ? dataserie.variableName : dataserie.l_scopes[0].name;
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent.toLocaleString() : t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR
                break;
            case "RECSS":
            case "AVANDALICAS":
            case "THALLA":
            case "CUMPLIMIENTO_LABORAL":

            case "SIMPLE_TEXT_COLOR_DISPLAYVALUE_UM":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = `${itemVal !== null ? itemVal.displayValue.toLocaleString() : t('no-data')}${dataserie.um}`;
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "EMPLEABILIDAD":

            case "SIMPLE_TEXT_COLOR_VALUEREAL":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = `${itemVal !== null ? itemVal.valueReal.toLocaleString() : t('no-data')}${dataserie.um}`;
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "FTE_OPEX":

            case "SIMPLE_TEXT_COLOR_DISPLAYVALUE":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = itemVal !== null && itemVal.displayValue !== 'null' ? itemVal.displayValue.toLocaleString(): t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "AVAILABILITY":
            case "UTILIZATION":

            case "SIMPLE_NO_COLOR_VALUEGOALPERCENT":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent.toLocaleString(): t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE
                break;
            case "GASTO_MES":
            case "GASTO_YTD":
            case "COMPLEX_2NO_COLOR_1BACK_COLOR_DISP_GOAL_DESVPERC":
                entity2.item.titleAux = dataserie.variableName;
                entity2.item.displayValue = `${itemVal !== null ? (!isNaN(itemVal.displayValue) ? itemVal.displayValue.toLocaleString() : itemVal.displayValue) : t('no-data')} ${dataserie.um}`;
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.titleAux = dataserie.variableName;
                entity2.item2.displayValue = `${itemVal !== null ? itemVal.valueGoal.toLocaleString() : t('no-data')} ${dataserie.um}`;
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.titleAux = dataserie.variableName;
                entity2.item3.displayValue =`${itemVal !== null ? Math.round(itemVal.desvPercent).toLocaleString() : t('no-data')}%`;
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR
                flag_special = true;
                break;
            case "FTE_PERMANENT":
            case "FTE_TEMPORAL":

            case "COMPLEX_2NO_COLOR_1TEXT_COLOR_DISP_GOAL_DESV":
                entity2.item.titleAux = dataserie.variableName;
                entity2.item.displayValue = itemVal !== null ? itemVal.displayValue.toLocaleString() : t('no-data');
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.titleAux = dataserie.variableName;
                entity2.item2.displayValue = itemVal !== null ? itemVal.valueGoal.toLocaleString() : t('no-data');
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.titleAux = dataserie.variableName;
                entity2.item3.displayValue = itemVal !== null ? itemVal.desv.toLocaleString() : t('no-data');
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                flag_special = true;
                break;
            case "TAG_N1":
            case "TAG_N2":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = itemVal !== null ? `${itemVal.valueGoalPercent.toLocaleString()}%`: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE
                break;
            default:
                break;
        }
        
        return flag_special ? entity2 : entity;
    }

    const findDSReportEntityScopeValue = (dataserie, component) => {
        let flag_special = false;
        let entity = {
            item: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
        }
        let entity2 = {
            item: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
            item2: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
            item3: {
                title: null,
                displayValue: 'null',
                color: 'o',
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE,
            },
        }

        const itemVal = !isNullUndefined(dataserie.l_scopes) ? (dataserie.l_scopes.length > 0 ?  dataserie.l_scopes[0]  : null) : null

        entity.item.title = component.htmlTitle;
        entity.item.color = itemVal !== null ? itemVal.color : t('no-data');

        entity2.item.title = component.htmlTitle;
        entity2.item.color = itemVal !== null ? itemVal.color: t('no-data');

        entity2.item2.title = component.htmlTitle;
        entity2.item2.color = itemVal !== null ? itemVal.color: t('no-data');

        entity2.item3.title = component.htmlTitle;
        entity2.item3.color = itemVal !== null ? itemVal.color: t('no-data');

        switch (JSON.parse(component.htmlStyle).exHtmlId) {
            case "DESEMPEÑO_KPI":
            case "ESTADO_FINANCIERO":
            case "MANEJO_FTE":
                
            case "SIMPLE_ICON_COLOR_SCOPE":
                entity.item.titleAux = !isNullUndefined(dataserie.variableName) ? dataserie.variableName : dataserie.l_scopes[0].name;
                entity.item.displayValue = itemVal !== null ? itemVal.scopeValue: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR
                break;
            case "RECSS":
            case "AVANDALICAS":
            case "THALLA":
            case "CUMPLIMIENTO_LABORAL":
                
            case "SIMPLE_TEXT_COLOR_DISPLAYVALUE_UM":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = `${itemVal !== null ? itemVal.displayValue: t('no-data')}${dataserie.um}`;
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "EMPLEABILIDAD":

            case "SIMPLE_TEXT_COLOR_VALUEREAL":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = `${itemVal !== null ? itemVal.valueReal: t('no-data')}${dataserie.um}`;
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "FTE_OPEX":

            case "SIMPLE_TEXT_COLOR_DISPLAYVALUE":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = itemVal !== null ? itemVal.displayValue: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                break;
            case "AVAILABILITY"://OJO NO ESTABA EN AMSA DESA
            case "UTILIZATION"://OJO NO ESTABA EN AMSA DESA

            case "SIMPLE_NO_COLOR_VALUEGOALPERCENT":
                entity.item.titleAux = dataserie.variableName;
                entity.item.displayValue = itemVal !== null ? itemVal.valueGoalPercent: t('no-data');
                entity.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE
                break;
            case "GASTO_MES":
            case "GASTO_YTD":

            case "COMPLEX_2NO_COLOR_1BACK_COLOR_DISP_GOAL_DESVPERC":
                entity2.item.titleAux = dataserie.variableName;
                entity2.item.displayValue = `${itemVal !== null ? itemVal.displayValue: t('no-data')} ${dataserie.um}`;
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.titleAux = dataserie.variableName;
                entity2.item2.displayValue = `${itemVal !== null ? itemVal.valueGoal: t('no-data')} ${dataserie.um}`;
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.titleAux = dataserie.variableName;
                entity2.item3.displayValue =`${itemVal !== null ? Math.round(itemVal.desvPercent) : t('no-data')}%`;
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR
                flag_special = true;
                break;
            case "FTE_PERMANENT":
            case "FTE_TEMPORAL":
                
            case "COMPLEX_2NO_COLOR_1TEXT_COLOR_DISP_GOAL_DESV":
                entity2.item.titleAux = dataserie.variableName;
                entity2.item.displayValue = itemVal !== null ? itemVal.displayValue: t('no-data');
                entity2.item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item2.titleAux = dataserie.variableName;
                entity2.item2.displayValue = itemVal !== null ? itemVal.valueGoal: t('no-data');
                entity2.item2.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.NONE

                entity2.item3.titleAux = dataserie.variableName;
                entity2.item3.displayValue = itemVal !== null ? itemVal.desv: t('no-data');
                entity2.item3.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR
                flag_special = true;
                break;
            default:
                break;
        }
        
        return flag_special ? entity2 : entity;
    }


    const findTypeInfoCommentEntity = (componentData, component) => {
        if (component.htmlBoardAnexoRef === "REPORT") {
            return {
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-reportcomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
        else if (component.htmlBoardAnexoRef === "CONTRACT") {
            return {
            
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-contractcomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
        else if (component.htmlBoardAnexoRef === "KPI") {
            return {
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-kpicomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
        else if (component.htmlBoardAnexoRef === "FTE") {
            return {
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-ftecomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
        else if (component.htmlBoardAnexoRef === "RECSS" || component.htmlBoardAnexoRef === "THALLA" || component.htmlBoardAnexoRef === "AVANDALICAS") {
            return {
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-recsscomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
        else if (component.htmlBoardAnexoRef === "RRLL") {
            return {
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-rllcomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
        else if (component.htmlBoardAnexoRef === "KPIS") {
            return {
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-kpiscomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
        else {
            return {
                title: !isNullUndefinedOrEmpty(componentData) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-kpiscomment') ,
                value: componentData.items.length > 0 ? componentData.items : [],
            }
        }
    }

    const findTypeInfoCustomTextEntity = (componentData, component) => {
        if (component.htmlBoardAnexoRef === "LOD") {
            return {
                title: !isNullUndefinedOrEmpty(componentData.item) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-lod') ,
                value: componentData.item ? componentData.item.value : "",
                id: componentData.item ? componentData.item.id : 0,
            }
        }
        else if (component.htmlBoardAnexoRef === "TICKET") {
            return {
                title: !isNullUndefinedOrEmpty(componentData.item) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-ticket') ,
                value: componentData.item ? componentData.item.value : "",
                id: componentData.item ? componentData.item.id : 0,
            }
        }
        else if (component.htmlBoardAnexoRef === "ADJUSTMENT") {
            return {
                title: !isNullUndefinedOrEmpty(componentData.item) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-adjustment') ,
                value: componentData.item ? componentData.item.value : "",
                id: componentData.item ? componentData.item.id : 0,
            }
        }
        else if (component.htmlBoardAnexoRef === "INYECTIONS") {
            return {
                title: !isNullUndefinedOrEmpty(componentData.item) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-inyections') ,
                value: componentData.item ? componentData.item.value : "",
                id: componentData.item ? componentData.item.id : 0,
            }
        }
        else if (component.htmlBoardAnexoRef === "RETENTIONS") {
            return {
                title: !isNullUndefinedOrEmpty(componentData.item) && !isNullUndefinedOrEmpty(componentData.boardComponentTitle) ? componentData.boardComponentTitle : t('data-lang-boxname-retentions') ,
                value: componentData.item ? componentData.item.value : "",
                id: componentData.item ? componentData.item.id : 0,
            }
        }
    }
    
    const findTypeInfoFinancialEntity = (component) => {
        let new_item = null

        if (component.item !== null) {
            new_item = component.item
            new_item.title = component.boardComponentTitle;
            new_item.colorType = enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR
        }
        else {
            new_item = {
                title: component.boardComponentTitle,
                colorType: enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR,
                color: null,
                dataserieId: null,
                displayValue: null,
                elementId: null,
                masterKpiNemo: null,
                serieTime: null,
                valueGoal: null,
                valueGoalPercent: null,
            }
        }
        
        return new_item;
    }

    const getCorrectDataserieList = (componentDataAndConfig) => {
        let data = componentDataAndConfig.componentData.items.find(x => x.id === componentDataAndConfig.componentData.boardComponentInfoId)

        return !isNullUndefined(data) ? data.l_ds : []
    }

    const getEmptyContainer = () => {
        return  <Card className="h-100 w-100 p-0 m-0">
                    <Card.Body className={`h-100 m-0 p-0 pt-1 rounded-bottom text-center )}`}>
                        <Row className="m-0 p-0 h-100">
                            <Col className='p-0 my-auto'>
                                <Loading
                                    inputParam_Style={{marginTop: 'auto'}}
                                    inputParam_Width = '30px'
                                    inputParam_Height = '30px'
                                />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
    }

    const renderComponent = (componentKey) => {
        try {
            const propertyName = enum__ComponentType_InvertedEnum[inputParam_ContainerComponent.componentTypeId];
            let componentDataAndConfig = boardComponentInfoRecursiveValues[propertyName] !== null ? boardComponentInfoRecursiveValues[propertyName].find(x => (x.componentConfig !== null && x.componentConfig !== undefined) ? (x.componentConfig.id === inputParam_ContainerComponent.id) : false) : null;
            let componentData = null;


            if (componentDataAndConfig === null) {
                return getEmptyContainer()
            }

            switch (componentDataAndConfig.componentConfig.componentTypeId) {
                case enum__ComponentType.ELEMENT_STADISTICS:
                    return <ELEMENT_STADISTICS
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ComponentConfig={componentDataAndConfig.componentConfig}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_BOOK_SUMMARY:
                    return <ELEMENT_BOOK_SUMMARY
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_ROLES:
                    return <ELEMENT_ROLES
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_LAST_MOVEMENTS:
                    return <ELEMENT_LAST_MOVEMENTS
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_KPI_COMMENT_EVENT:
                    return <ELEMENT_KPI_COMMENT_EVENT
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.SG3_HEADER:
                    return <SG3_HEADER
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.SG3KPI_CONSOLIDATE_MONTH:
                    return <SG3KPI_CONSOLIDATE_MONTH
                                inputParam_ReportHeaderMode={inputParam_ReportHeaderMode}
                                inputParam_HideHeader={false}
                                inputParam_HasPageElementId={inputParam_HasPageElementId}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ComponentConfig={componentDataAndConfig.componentConfig}
                                inputParam_TwoColumnsDisplay={inputParam_BoardType === enum__BOARD_TEMPLATE_TYPE.LANDING}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.CONTRACT_SERVICES:
                    return <CONTRACT_SERVICES
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_ElementId={inputParam_ElementId}
                            />
                case enum__ComponentType.CONTRACT_SERVICES_STATUS:
                    return <CONTRACT_SERVICES_STATUS
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.CONTRACT_KPI_COVERAGE:
                    return <CONTRACT_KPI_COVERAGE
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.CONTRACT_LAST_EDP:
                    return <CONTRACT_LAST_EDP
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.OCR_CHART:
                    return <OCR_CHART
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ReportHeaderMode={inputParam_ReportHeaderMode}
                                inputParam_ReportMode={inputParam_ReportHeaderMode}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_BoardId={inputParam_BoardId}
                            /> 
                case enum__ComponentType.OCR_CHART_LIST:
                    return <OCR_CHART_LIST
                                inputParam_HideHeader={false}
                                inputParam_ReportMode={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ReportHeaderMode={inputParam_ReportHeaderMode}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_ComponentConfig={componentDataAndConfig.componentConfig}
                            /> 
                case enum__ComponentType.OCR_CHART_GAUGE:
                    return <OCR_CHART
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ShowGauge={true}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_ContextualChart={inputParam_ContextualChart}
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_BoardId={inputParam_BoardId}
                            />
                case enum__ComponentType.SG3KPI_RADIAL:
                    return <SG3KPI_RADIAL
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ShowGauge={true}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.SG3KPI_RADIALOPF:
                    return <SG3KPI_RADIALOPF
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ShowGauge={true}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.SG3KPI_LASTOPF:
                    return <SG3KPI_LASTOPF
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ShowGauge={true}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.SG3KPI_MONITORING:
                    return <SG3KPI_MONITORING
                                inputParam_HideHeader={false}
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_ShowGauge={true}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.SG3KPI_CONTRACT_ADVANCE:
                    return <SG3KPI_CONTRACT_ADVANCE
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_OBLIGATIONS_CONTROL:
                    return <ELEMENT_OBLIGATIONS_CONTROL
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_CONTRACT_SEGMENT:
                    return <ELEMENT_CONTRACT_SEGMENT
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_HideCarteras={false}
                            /> 
                case enum__ComponentType.ELEMENT_CONTRACT_CATEGORY:
                    return <ELEMENT_CONTRACT_CATEGORY
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_CONTRACT_PORTFOLIO_SUMMARY:
                    return <ELEMENT_CONTRACT_PORTFOLIO_SUMMARY
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_CONTRACT_KPI_DETAIL:
                    return <ELEMENT_CONTRACT_KPI_DETAIL
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_KPI_FTE_CHART:
                    return <ELEMENT_KPI_FTE_CHART
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_KPI_AMOUNT:
                    return <ELEMENT_KPI_AMOUNT
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_KPI_FTE_TREE:
                    return <ELEMENT_KPI_FTE_TREE
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.PRODUCTS:
                    return <PRODUCTS
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_KPI_VARIABLE_DETAILS:
                    return  <ELEMENT_KPI_VARIABLE_DETAILS
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_Index={inputParam_Index}
                            /> 
                case enum__ComponentType.ELEMENT_KPI_SUMMARY:
                    return  <ELEMENT_KPI_SUMMARY
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_Index={inputParam_Index}
                            /> 
                case enum__ComponentType.ELEMENT_KPI_SCOPE:
                    return  <ELEMENT_KPI_SCOPE
                                inputParam_HideHeader={false}
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_Index={inputParam_Index}
                                inputParam_ContainerComponent={inputParam_ContainerComponent}
                                inputParam_BoardType={inputParam_BoardType}
                                setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                            /> 
                case enum__ComponentType.ELEMENT_BOOK_STATUS_SUMMARY:
                    return <ELEMENT_BOOK_STATUS_SUMMARY
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.INFO_TYPETEXT:
                    componentData = findTypeTextEntity(componentDataAndConfig.componentData, inputParam_ContainerComponent)
                    return <INFO_TYPETEXT
                                inputParam_Item={componentData}
                                //inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_ContainerComponent={inputParam_ContainerComponent}
                            />
                case enum__ComponentType.INFO_COMMENT:
                    componentData = findTypeInfoCommentEntity(componentDataAndConfig.componentData, inputParam_ContainerComponent)
                    return <INFO_COMMENT
                                inputParam_Component={inputParam_ContainerComponent}
                                inputParam_ComponentType={1}
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_Item={{
                                    id: !isNullUndefined(componentData.id) ? componentData.id : (!isNullUndefined(componentData.value) && !isNullUndefined(componentData.value[0]) ? componentData.value[0].boardComponentInfoId : null),
                                    title: componentData.title,
                                    comments: componentData
                                }}
                                inputParam_AuxComponentComment={
                                    boardComponentInfoRecursiveValues["INFO_COMMENT"].flatMap(x => x.componentData).find(x => x.boardComponentInfoId.toString() === componentDataAndConfig.componentData.htmlBoardAnexoRef)
                                }
                            />
                case enum__ComponentType.INFO_CUSTOMTEXT:
                    componentData = findTypeInfoCustomTextEntity(componentDataAndConfig.componentData, inputParam_ContainerComponent)
                    return <INFO_CUSTOMTEXT
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_Item={ componentData }
                        inputParam_Component={ inputParam_ContainerComponent }
                    />
                case enum__ComponentType.INFO_FINANCIAL:
                    return  <INFO_FINANCIAL
                                inputParam_Component={inputParam_ContainerComponent}
                                inputParam_Dataserie={null}
                                inputParam_HidePanels={true}
                                inputParam_Item={
                                    findTypeInfoFinancialEntity(componentDataAndConfig.componentData)
                                }
                                //inputParam_BoardStructure={inputParam_BoardStructure}
                                //inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE:
                    return  <ELEMENT_CONTRACT_EXPENSE_BALANCE
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_CONTRACT_SERVICE_SUMMARY:
                    return  <ELEMENT_CONTRACT_SERVICE_SUMMARY
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_CONTRACT_LIST_LAST_EDP:
                    return  <ELEMENT_CONTRACT_LIST_LAST_EDP
                                inputParam_HideHeader={false}
                                inputParam_ElementId={inputParam_ElementId}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_BoardType={inputParam_BoardType}
                                inputParam_UserPropsKpi={inputParam_UserPropsKpi}
                            /> 
                case enum__ComponentType.ELEMENT_CONTRACT_EDP_COVER:
                    return  <ELEMENT_CONTRACT_EDP_COVER
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL:
                    return  <ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_CONTRACT_LAST_EDP:
                    return  <ELEMENT_CONTRACT_LAST_EDP
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />           
                          
                case enum__ComponentType.ELEMENT_CONTRACT_EXCHANGE_RATE:
                    return  <ELEMENT_CONTRACT_EXCHANGE_RATE
                                inputParam_Component={inputParam_ContainerComponent}
                                inputParam_Dataserie={null}
                                inputParam_Item={componentDataAndConfig.componentData}
                            />           
                case enum__ComponentType.SG3BOOK_EVENTOS:
                case enum__ComponentType.SG3BOOK_LIBROS:
                case enum__ComponentType.SG3KPI_GAPEVENTOS:
                case enum__ComponentType.SG3KPI_GAPACCIONES:
                    if (hasInfoMultiComponentType === false) {
                        return  <InfoListDynamic
                            inputParam_BoardId={inputParam_BoardId}
                            inputParam_ComponentContent={componentDataAndConfig.componentData}
                        />
                    }
                    else {
                        return <></>
                    }







                case enum__ComponentType.INFO_SIMPLE_KPI:
                    componentDataAndConfig = boardComponentInfoRecursiveValues[enum__ComponentType_InvertedEnum[inputParam_ContainerComponent.componentTypeId]].find(x => x.componentConfig.id === inputParam_ContainerComponent.id);
                    componentData = findTypeInfoFinancialEntity(componentDataAndConfig.componentData, inputParam_ContainerComponent)
                    return  <INFO_FINANCIAL
                                inputParam_Component={null}
                                inputParam_Dataserie={null}
                                inputParam_HidePanels={true}
                                /*inputParam_ItemFields={[
                                    {usePartialTitle: false, name: "financialBreakthrough", field: "financialBreakthrough", symbol: "%"}, 
                                    {usePartialTitle: false, name: "physicalAdvance", field: "physicalAdvance", symbol: "%"},
                                    {usePartialTitle: false, name: "acceleration", field: "acceleration", symbol: ""}
                                ]}*/
                                inputParam_Item={ componentData }
                            />
                case enum__ComponentType.DS_SIMPLEDATA:
                    return  <INFO_FINANCIAL
                                inputParam_HidePanels={true}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_Component={inputParam_ContainerComponent}
                                inputParam_Dataserie={!isNullUndefined(componentDataAndConfig.componentData.items) && componentDataAndConfig.componentData.items.length !== 0 ? componentDataAndConfig.componentData.items[0] : null}
                                //inputParam_ItemFields={findDSReportField(inputParam_ContainerComponent)}
                                inputParam_Item={!isNullUndefined(componentDataAndConfig.componentData.items) ? findDSReportEntity(componentDataAndConfig.componentData.items[0], inputParam_ContainerComponent) : null}
                        />
                case enum__ComponentType.DS_SIMPLEDATA_PERFORMANCE:
                    return  <INFO_FINANCIAL
                                inputParam_HidePanels={true}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_Component={inputParam_ContainerComponent}
                                inputParam_Dataserie={!isNullUndefined(componentDataAndConfig.componentData.items) && componentDataAndConfig.componentData.items.length !== 0 ? componentDataAndConfig.componentData.items[0] : null}
                                //inputParam_ItemFields={findDSReportField(inputParam_ContainerComponent)}
                                inputParam_Item={!isNullUndefined(componentDataAndConfig.componentData.items) ? findDSReportEntityScopeValue(componentDataAndConfig.componentData.items[0], inputParam_ContainerComponent) : null}
                            />
                case enum__ComponentType.LIST:
                    return  <>
                        <Card className="h-100 w-100 p-0 m-0">
                            <Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                            {  componentDataAndConfig.componentData.boardComponentTitle !== null ? componentDataAndConfig.componentData.boardComponentTitle : t('data-lang-boxname-dataserie')}
                            </Card.Body>
                            <Card.Body className='px-1 py-0 h-100' style={{ overflowY: "auto", overflowX: "auto" }}>
                                {
                                    !groupDataseriesInOneList &&
                                    <BoardList
                                        inputParam_HidePanels={true}
                                        inputParam_BoardId={inputParam_BoardId}
                                        inputParam_ElementId={inputParam_ElementId}
                                        inputParam_DataserieList={getCorrectDataserieList(componentDataAndConfig)}
                                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                                    /> 
                                }
                                {
                                    groupDataseriesInOneList &&
                                    <BoardListGrouped
                                        inputParam_HidePanels={true}
                                        inputParam_UserPropsKpi={inputParam_UserPropsKpi}
                                        inputParam_BoardId={inputParam_BoardId}
                                        inputParam_ElementId={inputParam_ElementId}
                                        inputParam_DataserieList={getCorrectDataserieList(componentDataAndConfig)}
                                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                                        inputParam_ContainerComponentIndex={inputParam_ContainerComponentIndex}
                                    />
                                }
                            </Card.Body>
                        </Card>
                    </>



                case enum__ComponentType.ELEMENT_CONTRACT_LIST_TO_COMPARE:
                    return  <ELEMENT_CONTRACT_LIST_TO_COMPARE
                                inputParam_HideHeader={false}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_UseFake ={false}
                            />

                case enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_OPF:
                    return  <CONSOLIDATE_GROUP_CONSOLIDATE_OPF
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_UseFake ={false}
                            />
            
                case enum__ComponentType.CONSOLIDATE_GROUP_LIST_TO_SELECT:
                    return  <CONSOLIDATE_GROUP_LIST_TO_SELECT
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_UseFake={false}
                                inputParam_BoardId={inputParam_BoardId}
                            />
                case enum__ComponentType.CONSOLIDATE_GROUP_CONSOLIDATE_CHART:
                    return  <CONSOLIDATE_GROUP_CONSOLIDATE_CHART
                                inputParam_UseFake ={false}
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_OnMaximize={inputParam_OnMaximize}
                                inputParam_IsMaximized={inputParam_IsMaximized}
                            />

                case enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE:
                    return  <CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE
                                inputParam_UseFake ={false}
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                            />


                case enum__ComponentType.ELEMENT_CONTRACT_EDP_RESUMEN:
                    return  <ELEMENT_CONTRACT_EDP_RESUMEN
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_CONTRACT_EDP_DISTRIBUCION:
                    return  <ELEMENT_CONTRACT_EDP_DISTRIBUCION
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            />
                case enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH:
                    return  <ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH
                                inputParam_UseFake={false}
                                inputParam_HideHeader={false}
                                inputParam_ComponentContent={componentDataAndConfig.componentData}
                                inputParam_BoardStructure={inputParam_BoardStructure}
                                inputParam_Container={inputParam_Container}
                            /> 
                case enum__ComponentType.ELEMENT_CONTRACT_EDP_MONTOS_GRAPH:
                    return <ELEMENT_CONTRACT_EDP_MONTOS_GRAPH
                        inputParam_HideHeader={false}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_BoardStructure={inputParam_BoardStructure}
                        inputParam_Container={inputParam_Container}
                    /> 
                case enum__ComponentType.ELEMENT_CONTRACT_MOTNHS:
                    componentData = findTypeTextEntity(componentDataAndConfig.componentData, inputParam_ContainerComponent)
                    return <ELEMENT_CONTRACT_MOTNHS
                                inputParam_Item={componentData}
                                inputParam_ContainerComponent={inputParam_ContainerComponent}
                            />
                case enum__ComponentType.ELEMENT_CONTRACT_EDP_PARTIDAS_TBL:
                    return <ELEMENT_CONTRACT_EDP_PARTIDAS_TBL
                        inputParam_HideHeader={false}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_BoardStructure={inputParam_BoardStructure}
                        inputParam_Container={inputParam_Container}
                    /> 
                case enum__ComponentType.ELEMENT_KPI_CONTRACT_LIST_BYROLE:
                    return <ELEMENT_CONTRACT_HOME_EXTERNAL
                        inputParam_HideHeader={false}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                    /> 
                case enum__ComponentType.ELEMENT_KPI_LIST_BYROLE:
                    return <ELEMENT_CONTRACT_HOME_EXTERNAL_KPI_SCOPE
                        inputParam_HideHeader={false}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_BoardStructure={inputParam_BoardStructure}
                        inputParam_Container={inputParam_Container}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_Index={inputParam_Index}
                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                        inputParam_BoardType={inputParam_BoardType}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                    /> 
                
                case enum__ComponentType.POWERBI_COMPONENT_TABLE:
                    return <POWERBI_COMPONENT_TABLE
                        inputParam_HideHeader={true}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_BoardStructure={inputParam_BoardStructure}
                        inputParam_Container={inputParam_Container}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                        inputParam_BoardType={inputParam_BoardType}
                    />

                case enum__ComponentType.POWERBI_COMPONENT_KEY_KPIS:
                    return <POWERBI_COMPONENT_KEY_KPIS
                        inputParam_HideHeader={true}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_BoardStructure={inputParam_BoardStructure}
                        inputParam_Container={inputParam_Container}
                        inputParam_BoardId={inputParam_BoardId}
                        inputParam_ContainerComponent={inputParam_ContainerComponent}
                        inputParam_BoardType={inputParam_BoardType}
                    /> 
                case enum__ComponentType.POWERBI_COMPONENT_OCR:
                    return <POWERBI_COMPONENT_OCR
                        inputParam_Container={inputParam_Container}
                        inputParam_HideHeader={false}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_BoardStructure={inputParam_BoardStructure}
                    /> 
                case enum__ComponentType.CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE:
                    return <CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE
                        inputParam_Container={inputParam_Container}
                        inputParam_HideHeader={false}
                        inputParam_ComponentContent={componentDataAndConfig.componentData}
                        inputParam_BoardStructure={inputParam_BoardStructure}
                    /> 
                default:
                    return <></>
            }
        } catch (error) {
            console.log(error)
            return getEmptyContainer()
        }
    }

    //Render de componente.
    return (boardComponentInfoRecursiveValues && renderComponent(inputParam_ContainerComponent));
}

export default BoardComponentInfoContent;